import { ExamActionList, ExamType } from "../actions/examAction";
import { Action } from "../actions/types";

const initialValue: Array<ExamType> = [];

const examReducer = (state: Array<ExamType> = initialValue, action: Action) => {
    switch (action.type) {
        case ExamActionList.ADD_EXAM:
            return [
                ...state,
                action.data,
            ];

        case ExamActionList.UPDATE_EXAM:
            const updated = [...state].slice();
            const index = updated.findIndex(u => u.id === action.data.id);

            if (index > -1) {
                updated[index] = {
                    ...action.data,
                };
            }

            return updated;

        case ExamActionList.FETCH_EXAM:
            return action.data;

        case ExamActionList.DELETE_EXAM:
            return state.filter(s => s.id !== action.data);

        default:
            return state;
    }
}

export default examReducer;



